//import React from 'react';
//import {render} from 'react-dom';
//import * as ReactDOMClient from 'react-dom/client';
import {createRoot} from 'react-dom/client';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
//import Reboot from '@material/material/core/Reboot';
import { ThemeProvider, createTheme } from '@mui/material/styles';
//import {purple,green,grey,pink,yellow} from '@material/material/core/colors';
import LoginPage from './components/startup/LoginPage';
import HomePage from './components/startup/HomePage';
import {bizpost} from './ajax';
import {createColor} from './components/themes/colors';
import "./index.css";

const gold = {light:'#decc95',main:'#ffc107',dark:'#664e04',contrastText: '#000000'};
const lemon = {light:'#c1e312',main:'#b5e312',dark:'#bdde14',contrastText: '#ffffff'};
const temp = {light:'',main:'',dark:'',contrastText: '#ffffff'};

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      light: '#a67c52',
      main: '#865F36',
      dark: '#5d4225',
      contrastText: '#ffffff',
    },
    secondary: {...lemon},
    background: {
      default: '#000000',
      paper: '#121212',
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
    // secondary: {
    //   //m:#ffc107,l:#decc95,d:#664e04
    //   light: '#c1e312', //'#843e9c', //'#c3DA4B', //'#ffdb99',
    //   main: '#b5e312', //'#540d6d', //'#e1a96a',//'#BDDA57',
    //   dark: '#bdde14', //'#280041', //'#C3DA4B', //'#ad7a3d',
    //   contrastText: "#ffffff", //'#000000',
    // },
    cocoa: createColor('#964B00'),
    goldy: createColor('#FFD700'),
    lemon: createColor('#BDDE14'),
    oldie: createColor('#757575'),
    pinky: createColor('#D81B60'),
    tealy: createColor('#60D81B'),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: '#865F36',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#a67c52',
          },
        },
        containedPrimary: {
          backgroundColor: '#865F36',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#a67c52',
          },
        },
      },
    },
  },
});

const start = async()=>{
  const logincontext = false;

  try{
    const json = {s:'security',a:'basicdata',m:'mfa'};
    //startLoading();
    const response = await bizpost(json);
    console.log('login response ',response);
    var page;
    if(!response.bd){
      page = (<LoginPage home={HomePage} apptheme={theme} logincontext={logincontext} />);
    }
    else{
      page = <HomePage  udata={response} />;
    }
  }
  catch(error){
    page = <LoginPage home={HomePage} apptheme={theme} logincontext={logincontext} />;
  }
  finally{
    //stopLoading();
    const container = document.getElementById('app');

    // Create a root.
    if(container !== null){
      const root = createRoot(container);
      root.render(<ThemeProvider theme={theme}>{page}</ThemeProvider>);
    }
    
    //render(<MuiThemeProvider theme={theme}>{page}</MuiThemeProvider>, document.getElementById('app'));
  }
}

start();


// // Before
// import { render } from 'react-dom';
// const container = document.getElementById('app');
// render(<App tab="home" />, container);

// // After
// import { createRoot } from 'react-dom/client';
// const container = document.getElementById('app');
// const root = createRoot(container); // createRoot(container!) if you use TypeScript
// root.render(<App tab="home" />);
